module.exports = __webpack_public_path__ + "img/sportinmarl_logo-1.29b0974c.png";